import { render } from "./vehicleInMotion.vue?vue&type=template&id=24d1a828"
import script from "./vehicleInMotion.vue?vue&type=script&lang=js"
export * from "./vehicleInMotion.vue?vue&type=script&lang=js"

import "./vehicleInMotion.vue?vue&type=style&index=0&id=24d1a828&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__